/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Document category accepted as support for a buyer-agent offer. */
export type AgentOfferDocumentUploadPurpose =
  /** ABA disclosure associated with the buyer-agent offer. */
  | 'ABA_DISCLOSURE'
  /** Opendoor addendum associated with the buyer-agent offer. */
  | 'OPENDOOR_ADDENDUM'
  /** Another document supporting the buyer-agent offer. */
  | 'OTHER'
  /** Letter showing the buyer has mortgage pre-approval. */
  | 'PRE_APPROVAL_LETTER'
  /** Evidence of funds available for the buyer-agent offer. */
  | 'PROOF_OF_FUNDS'
  /** Purchase agreement supporting the buyer-agent offer. */
  | 'PURCHASE_AGREEMENT';

export type CreateAgentOfferDocumentUploadUrlMutationVariables = Exact<{
  listingId: Types.Scalars['ID']['input'];
  purpose: Types.AgentOfferDocumentUploadPurpose;
  fileName: Types.Scalars['NonEmptyString']['input'];
  contentType: Types.Scalars['NonEmptyString']['input'];
  contentLength: Types.Scalars['SafeInt']['input'];
  submissionId?: Types.Scalars['UUID']['input'] | null | undefined;
}>;


export type CreateAgentOfferDocumentUploadUrlMutation = { agentOfferDocumentUploadUrlCreate:
    | { __typename: 'AgentOfferDocumentUploadUrl', submissionId: Types.Scalars['UUID']['output'], url: Types.Scalars['URL']['output'], document: { id: Types.Scalars['ID']['output'] } }
    | { __typename: 'InvalidInputError', message: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', message: Types.Scalars['String']['output'] }
    | { __typename: 'UnauthorizedError', message: Types.Scalars['String']['output'] }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const CreateAgentOfferDocumentUploadUrlDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateAgentOfferDocumentUploadUrl($listingId: ID!, $purpose: AgentOfferDocumentUploadPurpose!, $fileName: NonEmptyString!, $contentType: NonEmptyString!, $contentLength: SafeInt!, $submissionId: UUID) {
  agentOfferDocumentUploadUrlCreate(
    input: {listingId: $listingId, purpose: $purpose, fileName: $fileName, contentType: $contentType, contentLength: $contentLength, submissionId: $submissionId}
  ) {
    __typename
    ... on AgentOfferDocumentUploadUrl {
      document {
        id
      }
      submissionId
      url
    }
    ... on Error {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<CreateAgentOfferDocumentUploadUrlMutation, CreateAgentOfferDocumentUploadUrlMutationVariables>;